exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-input-title {\n  font-size: 0.845rem;\n  cursor: pointer;\n}\n.avatar-upload {\n  width: 72px;\n  height: 72px;\n  object-fit: cover;\n}", ""]);

// exports
